export interface SendDataBase<T> {
  id: string;
  estateId: string;
  createTimestamp: number;
  lastUpdate: number;
  status: T;
  statusTimestamp: number;
}

export enum MsgStatus {
  PENDING = 'pending',
  PROCESSED = 'processed',
  SENT = 'sent',
  FAILED = 'failed',
  CANCELED = 'canceled'
}
